module.exports = "<h1 mat-dialog-title>{{'igo.confirmDialog.title' | translate}}</h1>\r\n<div mat-dialog-content>{{confirmMessage}}</div>\r\n<div mat-dialog-actions>\r\n  <button mat-button color=\"primary\" (click)=\"dialogRef.close(true)\">{{'igo.confirmDialog.confirmBtn' | translate}}</button>\r\n  <button mat-button (click)=\"dialogRef.close(false)\">{{'igo.confirmDialog.cancelBtn' | translate}}</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/shared/confirm-dialog/confirm-dialog.component.html
// module id = 847
// module chunks = 0